import type { DpEvent } from '@/core/events/DpEvent';

export class NavbarVisibilityChange implements DpEvent {
  static readonly eventName = 'Dashboard:NavbarVisibilityChange';

  readonly name = NavbarVisibilityChange.eventName;

  constructor(readonly state: 'shown' | 'hidden') {}
}
